import { Outlet, useNavigate } from 'react-router-dom'

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createContactAddressCompanyUsers } from '../../api/POST/contactAddressCompanyUsers'
import userRole from '../../config/userRole'
import { useQueryUser } from '../../hooks/fetch/auth/useQueryUser'
import { useQueryCsrfToken } from '../../hooks/fetch/useQueryCsrfToken'
import { selectRole, setLoggedinUser } from '../../slices/authSlice'
import NowLoading from '../UtilComponent/level_1/NowLoading'
import ContactHeader from './ContactHeader/ContactHeader'
import { setContactFilterType } from '../../slices/contactAddressSlice'

const ContactPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const role = useSelector(selectRole)

  const { data: loggedInUser } = useQueryUser()

  useEffect(() => {
    if (loggedInUser) {
      dispatch(setLoggedinUser(loggedInUser))
      dispatch(setContactFilterType(loggedInUser.role === 4 ? 'personal' : 'shared'))
    }
  }, [dispatch, loggedInUser])

  const { isLoading } = useQueryCsrfToken()
  if (isLoading) return <NowLoading />

  return (
    <span className="stack">
      <ContactHeader />
      <Outlet />
      {role === userRole['カンパニー管理者'] && (
        <button
          onClick={async () => {
            await createContactAddressCompanyUsers()
            navigate(0)
          }}
        >
          すべてのカンパニー内ユーザーを共有連絡先に追加する
        </button>
      )}
    </span>
  )
}

export default ContactPage
